/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './setup-manual.html';

import { $root } from '../../player/player';
import { mixinType } from '../../util.type';
import focus from '../focus/focus-directive';
import SetupHeader from './setup-header';

export default defineComponent({
  name: 'SetupManual',
  template,
  components: { SetupHeader },
  created() {
    this.submitted = false;
  },
  directives: { focus },
  data() {
    return mixinType(
      {
        field: {
          deviceName: {
            label: 'Device name (optional)',
            value: this.deviceName
          },
          password: {
            label: 'Password',
            validator: 'required',
            value: this.password
          },
          username: {
            label: 'E-mail',
            validator: 'required',
            value: this.username
          }
        }
      },
      /**
       * @type {{
       *   submitted: boolean;
       * }}
       */
      ({})
    );
  },
  emits: {
    back() {},
    /**
     * @param {string} deviceName
     * @param {string} username
     * @param {string} password
     */
    submit(deviceName, username, password) {}
  },
  methods: {
    /**
     * @param {Error} error
     */
    handleError(error) {
      $root(this).logger.error(error);
    },
    onBack() {
      this.$emit('back');
    },
    onChange() {
      new Promise((resolve) => {
        if (!this.submitted) {
          return resolve(undefined);
        }
        return resolve(this.$validator.validateAll());
      }).catch((error) => this.handleError(error));
    },
    onSubmit() {
      new Promise((resolve) => {
        this.submitted = true;
        return resolve(this.$validator.validateAll());
      })
        .then((valid) => {
          if (!valid) {
            return;
          }
          const { field } = this;
          this.$emit(
            'submit',
            field.deviceName.value,
            field.username.value,
            field.password.value
          );
        })
        .catch((error) => this.handleError(error));
    }
  },
  props: {
    deviceName: { type: String, required: true },
    isOnline: { type: Boolean, required: true },
    password: { type: String, required: true },
    username: { type: String, required: true }
  }
});
